import { Component } from '@angular/core';
import { PlaceholderPageComponent } from '../../../pages/placeholder/placeholder-page.component';

@Component({
  selector: 'app-basic-calculator',
  standalone: true,
  imports: [PlaceholderPageComponent],
  template: `
    <app-placeholder-page 
      title="calculatorList.basic.title" 
      icon="calculator">
    </app-placeholder-page>
  `
})
export class BasicCalculatorComponent {}